export default {
    email: 'メールアドレス',
    mailaddress: 'メールアドレス'
};
